import { AUTH_MESSAGE_CODES, PERSONAL_NUMBER_CODES } from "@obg/ngx.core";

export const LOGIN_TRANSLATION_PREFIX = "login";

// TODO: To cover with config
export const EXCLUDED_GENERIC_ERROR_MESSAGE_CODES = [
	AUTH_MESSAGE_CODES.login.termsAndConditionsNotAccepted,
	AUTH_MESSAGE_CODES.login.latestTermsAndConditionsNotAccepted,
	AUTH_MESSAGE_CODES.login.latestPrivacyPolicyNotAccepted,
	AUTH_MESSAGE_CODES.login.latestEntityLegalNoticeNotAccepted,
	AUTH_MESSAGE_CODES.login.consentsNotAccepted,
	AUTH_MESSAGE_CODES.login.invalidCredentials,
	AUTH_MESSAGE_CODES.login.credentialsNotFound,
	AUTH_MESSAGE_CODES.login.customerNotVerified,
	AUTH_MESSAGE_CODES.login.twoFactorAuthenticationRequired,
	AUTH_MESSAGE_CODES.login.profileNotCompleted,
	AUTH_MESSAGE_CODES.login.geofencingMultipleTries,
	AUTH_MESSAGE_CODES.login.geofencingGeneralError,
	AUTH_MESSAGE_CODES.login.geofencingServerError,
	...Object.values(PERSONAL_NUMBER_CODES),
];

export const EXCLUDED_TWO_FACTOR_AUTH_MESSAGE_CODES = [
	AUTH_MESSAGE_CODES.login.twoFactorAuthenticationMaxAttemptReached,
	AUTH_MESSAGE_CODES.login.termsAndConditionsNotAccepted,
	...EXCLUDED_GENERIC_ERROR_MESSAGE_CODES,
];

export const LOGIN_SELF_EXCLUSION_ERROR_CODE = "E_SESSIONS_LOGIN_CUSTOMERSELFEXCLUDEDCENTRALLY";

export const TWO_FACTOR_AUTH_USER_IS_LOCKED_TEXT = "login.user-is-locked";

export const ACCOUNT_NOT_VERIFIED_ERROR_CODE = AUTH_MESSAGE_CODES.login.accountNotVerified;

export const gtmEventTags = {
	formName: "Force_Reset_Password",
	genericFormCancel: "GenericFormCancel",
};
